"use client"; // Error components must be Client Components

import { Button } from "@/components/ui/button";
import { formatJsError } from "@/lib/format-js-error";
import { SentryService } from "@/services/sentry/sentry-service";
import Image from "next/image";
import { useEffect } from "react";

interface ErrorProps {
  error: Error & { digest?: string };
  reset: () => void;
}

export default function Error({ error, reset }: ErrorProps) {
  useEffect(() => {
    // Log the error to an error reporting service
    SentryService.captureException(error);
  }, [error]);

  const resetError = () => {
    reset();
  };

  return (
    <div className="grid min-h-screen place-items-center gap-3 py-12">
      <Image
        src={"/error.svg"}
        width={512}
        height={512}
        alt={"error-graphic"}
      />
      <h2 className="text-center text-2xl font-semibold">
        Something went wrong
      </h2>
      <h3 className="text-center text-destructive">{formatJsError(error)}</h3>
      <Button
        onClick={resetError}
        gtmEvent={{
          event: "click",
          eventCategory: "error",
          eventLabel: "try-again",
          eventAction: "reset",
        }}
      >
        Try again
      </Button>
    </div>
  );
}
